import {environment} from "@enviroments/environment";

export class CommonConstant {
    static ON_DESTROY : string = "ON_DESTROY";

    // storage
    static CART_INFO_TMP : string = "cardInfoTmp";
    static LINK_CART : string = "linkCart";
    static LINK_CART_PRODUCTS : string  = "linkCartProducts";
    static LINK_GUEST : string = "linkGuest";
    static PRODUCT_RECENT : string = "pdtRecent";
    static LEN_CART : string = "lenCart";
    static PAGE_CART : string = "pageCart";
    static URL_WOWNET : string = environment.urlWownet;
    static CHECK_ITEM_PRODUCT : string = "checkItemProduct";
    static STR_IS_CHECK_REGISTER : string = "str_is_check_register";
    static USER_ID2 : string = "userid2";
    static CONSUMER : string = "consumer";
    static USER_ID : string = "userId";
	static FLAG_POINT : string = "flag_point";
	static GUEST_CART : string = "guest_cart";
	static MEMBER : string = "member";
	static ORDER_NO_TMP : string = "ord_no_tmp";
    static SHARE_URL : string = "shareURL";
	static WORK_KIND: string = "workKind";
	static APPLE_USER: string = "apple_user";
	static GOOGLE_USER: string = "googleUser";    
    
    static REMAIN_PASSWORD: string = "remain_pass";
    static REMAIN_USER: string = "remain_user";

    // Common
    static YES = "Y";
    static NO = "N";
    static SLASH = "/";
	static SHARP = "#";
	static HYPHEN = "-";
    static PV1 = "pv1";
    static PV2 = "pv2";
    static PV3 = "pv3";
    static KOREA_CODE = "KR";
    static SGP_CODE = "SG";
    static BLANK = "";
    static LAST_MONTH = 11;
    static SELECT_LABEL = "선택";
	static SEARCH_PAST = "P";
	static SEARCH_FUTURE = "F";
	static SEARCH_NOW = "Y";
	static OK = "OK";

    static MAX_LENGTH_PRODUCT_BRAND = 3;
	static MAX_LENGTH_PRODUCT_NEW = 8 ;
	static TITLE_PAGE = "LOOAL";

	static LIST_CART_MODAL = "addCartModal";
	static ORDER_MODAL = "orderModal";
	static MEMBER_MODAL = "memberModal";
	static ADO_MODAL = "adoModal";
	static ADO_PRODUCT_MODAL = "adoProductModal";
	static ZIP_MODAL = "zipModal";
	static PREPAY_MODAL = "prepayModal";
	static REGISTER_PREPAY_MODAL = "registerPrepayModal";
	static DELI_MODAL = "deliModal";
	static RESIDENT_MODAL = "residentModal";

	static SINGLE_DATE = "single";
	static RANGE_DATE = "range";

	static COMMON_FORMAT_DATE = "YYYYMMDD";
    static EMPTY_MAX_ROW = 5;
    static PREVIOUS_URL = "previous_url";
    static URL_PRODUCT_DETAIL = "/shopping-mall/product/";


}
